module.exports = __webpack_public_path__ + "static/img/1_11_1.67d0e63e.jpg";